import React from 'react';
import { Row, Col } from 'reactstrap';
import vcImage from "../assets/VC.jpeg";

export default function ViceChancellormessage() {
    return (
        <div className="container mt-5 mb-5">
            <Row className="align-items-start mb-2">
                {/* Image Column */}
                <Col md={3} className="text-center" style={{ marginTop: "6rem" }}>
                    <img
                        src={vcImage}
                        alt="Vice Chancellor"
                        className="img-fluid rounded shadow-sm"
                        style={{ maxHeight: "250px", objectFit: "cover" }}
                    />
                </Col>


                <Col md={9}>

                    <div
                        style={{
                            backgroundColor: "#77236b",
                            padding: "12px 40px",
                            borderRadius: "8px",
                            border: "1px solid #cdd6f3",
                            boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
                            color: "#fff",
                            textAlign: "center",
                            width: "100%",
                            marginBottom: "2rem"
                        }}
                    >
                        <h4 className="fw-bold text-white m-0">कुलपति सन्देश</h4>
                    </div>

                    {/* Vice Chancellor Message Body */}
                    <div
                        style={{
                            textAlign: "justify",
                            lineHeight: "1.9",
                            fontSize: "1.1rem",
                            backgroundColor: "#f9f9f9",
                            padding: "30px 25px",
                            borderRadius: "12px",
                            boxShadow: "0 0 12px rgba(0, 0, 0, 0.12)",
                            marginBottom: "1.5rem",
                        }}
                    >
                        <p style={{ textIndent: '150px', textAlign: 'justify' }}>
                            संस्कृत भाषा भारत के सार (भारत की आत्मा) के रूप में भारतीय संस्कृति की संरक्षक और पोषक है।
                            संस्कृत के बिना संपूर्ण और अखंड भारत की कल्पना करना असंभव है। इसीलिए कहा गया है कि
                            "भारतस्य प्रतिष्ठिते द्वे संस्कृतं संस्कृतस्तथा" अर्थात् भारत की प्रतिष्ठा संस्कृत भाषा और
                            उसकी संस्कृति से है। इस भारत का आधार स्तंभ, जिसकी सभी पूजा करते हैं और जिसका स्वागत करते हैं,
                            संस्कृत है। इसलिए भारतीय ज्ञान प्रणाली को जानने के लिए संस्कृत भाषा और संस्कृत शास्त्रों को
                            सीखना आवश्यक है।
                        </p>
                        <p style={{ textIndent: '150px', textAlign: 'justify' }}>
                            भारतीय वैदिक सभ्यता और भारतीय संस्कृति सरस्वती नदी के तट पर विकसित हुई, इसलिए इतिहास की दृष्टि
                            से हरियाणा क्षेत्र और कैथल नगरी (वैदिकालीन कपिष्ठल) का विशेष स्थान है। यह भूमि प्रागैतिहासिक
                            ऋषि कपिल और वेदव्यास की तपोभूमि है। आमतौर पर भारतीय संस्कृति के तीन काल स्वीकार किए जाते हैं:
                            वैदिक काल, रामायण काल और महाभारत काल। इस स्थान का इन तीनों काल से विशेष संबंध है।
                        </p>
                        <p style={{ textIndent: '150px', textAlign: 'justify' }}>
                            वैदिक सभ्यता में कपिष्ठल का वर्णन मिलता है तथा कृष्ण यजुर्वेद की भी कठ-कपिष्ठल नाम से एक शाखा
                            मिलती है। यदि रामायण काल की बात करें तो इस कपिष्ठल का सीधा संबंध लव और कुश के जन्म से है।
                            यहां लव-कुश तीर्थ नाम का एक धार्मिक स्थल आज भी विद्यमान है। इस कपिष्ठल का महाभारत काल से
                            संबंध सर्वविदित है। विश्व का सबसे बड़ा महाभारत युद्ध कुरुक्षेत्र में लड़ा गया था जो कैथल के
                            बिल्कुल नजदीक स्थित है।
                        </p>
                        <p style={{ textIndent: '150px', textAlign: 'justify' }}>
                            अड़तालीस कोस का यह क्षेत्र कुरुक्षेत्र के नाम से सर्वत्र प्रसिद्ध है। इसी स्थान पर भगवान
                            हनुमान जी धनुर्धर अर्जुन के रथ की ध्वजा पर आरूढ़ हुए थे। इसलिए इस कपिष्ठल का भारतीय संस्कृति
                            में विशेष स्थान है।
                        </p>
                        <p style={{ textIndent: '150px', textAlign: 'justify' }}>
                            इन सभी बातों को ध्यान में रखते हुए हरियाणा सरकार ने वर्ष 2018 में इस स्थान पर महर्षि वाल्मीकि
                            संस्कृत विश्वविद्यालय की स्थापना की। यह विश्वविद्यालय बहुत ही कम समय में पूरे भारत में
                            प्रसिद्ध हो गया है और ज्ञान जिज्ञासुओं के लिए आकर्षण का केंद्र बन गया है।
                        </p>
                        <p style={{ textIndent: '150px', textAlign: 'justify' }}>
                            संस्कृत के प्रचार-प्रसार में निरंतर संलग्न यह विश्वविद्यालय बहुत तेज गति से अपने लक्ष्य की ओर
                            बढ़ रहा है। इस विश्वविद्यालय में वेद, उपनिषद, रामायण, महाभारत, दर्शन, पुराण, धर्मशास्त्र,
                            ज्योतिष, वास्तुशास्त्र आदि प्राचीन शास्त्रों की शिक्षा के साथ-साथ योग, आयुर्वेद, कंप्यूटर,
                            जीवन प्रबंधन कौशल आदि आधुनिक विषयों की भी शिक्षा देकर भारतीय प्राचीन विरासत को संरक्षित और
                            संवर्धित किया जा रहा है।
                        </p>
                        <p style={{ textIndent: '150px', textAlign: 'justify' }}>
                            इसी प्रकार यह विश्वविद्यालय भारतीय ज्ञान परंपरा के विशिष्ट प्रशिक्षण संस्थान के रूप में
                            भारतीय सांस्कृतिक मूल्यों के प्रचार-प्रसार के लिए प्रतिबद्ध है।
                        </p>
                        <p style={{ textIndent: '150px', textAlign: 'justify' }}>
                            मेरी कामना है कि यह विश्वविद्यालय न केवल हरियाणा राज्य को लाभान्वित करेगा, अपितु यह सांस्कृतिक
                            मार्गदर्शन, अनुसंधान, नवाचार और भारतीय पारंपरिक ज्ञान के प्रकाश का प्रसार करके पूरे भारत को
                            आलोकित करेगा।
                        </p>

                        <p className="text-end mt-5 mb-0">
                            <strong>प्रो. राजेंद्र कुमार अनायत</strong><br />
                            कुलपति
                        </p>
                    </div>
                </Col>
            </Row>
        </div>
    );
}
